export * from './lib/dynamic-report-general.module';
export * from './lib/dynamic-report-http-loader.service';
export * from './lib/dynamic-report-general.model';
export * from './lib/dynamic-report-general.dto';
export * from './lib/dynamic-report-general.interface';
export * from './lib/dynamic-report-general-list/dynamic-report-general-list.module';
export * from './lib/dynamic-report-general-create/dynamic-report-general-create.module';
export * from './lib/dynamic-report-general-form/dynamic-report-general-form.module';
export * from './lib/dynamic-report-general-edit/dynamic-report-general-edit.module';
export * from './lib/dynamic-report-general-detail/dynamic-report-general-detail.module';
